import React, { createContext, useContext, useState } from "react";
import axios from "../lib/axios";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    let role = sessionStorage.getItem("role");
    if (!role || role === "undefined") role = null;

    const email = sessionStorage.getItem("email") || null;

    return role ? { role, email } : null;
  });
  const navigate = useNavigate();

  const login = ({ role, email }) => {
    sessionStorage.setItem("role", role);
    if (email) {
      sessionStorage.setItem("email", email);
    } else {
      sessionStorage.removeItem("email");
    }
    setAuth({ role, email: email || null });
  };

  const logout = async () => {
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("email");
    setAuth(null);
    try {
      await axios.post("/logout");
    } catch (e) {
      console.warn("Logout failed");
    }
    navigate("/authentication/sign-in");
  };

  return <AuthContext.Provider value={{ auth, login, logout }}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAuth = () => useContext(AuthContext);
